/**
 * 결제 승인 훅
 * FSD: features/subscription/payment-result/hooks
 */

import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentApprovalAPI, ApprovalData } from '../api/payment-approval-api';

export const usePaymentApproval = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('결제 처리 중...');
  const [transactionId, setTransactionId] = useState<string | null>(null);

  useEffect(() => {
    processPaymentApproval();
  }, []);

  const processPaymentApproval = async () => {
    try {
      const approvalData: ApprovalData = {
        AuthResultCode: searchParams.get('AuthResultCode') || '',
        AuthResultMsg: searchParams.get('AuthResultMsg') || '',
        TxTid: searchParams.get('TxTid') || '',
        AuthToken: searchParams.get('AuthToken') || '',
        PayMethod: searchParams.get('PayMethod') || undefined,
        MID: searchParams.get('MID') || '',
        Moid: searchParams.get('Moid') || '',
        Amt: searchParams.get('Amt') || '',
        NextAppURL: searchParams.get('NextAppURL') || '',
        NetCancelURL: searchParams.get('NetCancelURL') || '',
      };

      if (!approvalData.TxTid || !approvalData.Moid) {
        throw new Error('결제 정보가 불완전합니다');
      }

      const response = await paymentApprovalAPI.approvePayment(approvalData);

      if (response.success) {
        setStatus('success');
        setMessage('결제가 완료되었습니다');
        setTransactionId(response.data?.TID || null);

        setTimeout(() => {
          navigate('/payment/history');
        }, 2000);
      } else {
        setStatus('error');
        setMessage(`결제 실패: ${response.message}`);
      }
    } catch (error: any) {
      setStatus('error');
      setMessage(`오류 발생: ${error.message}`);

      setTimeout(() => {
        navigate(-1);
      }, 5000);
    }
  };

  return { status, message, transactionId };
};
